import { LoginResponsePayload } from "../../services/account/login/types";
import { UserRoles } from "../../types/user-roles";

interface Login {
  type: "LOGIN_SUCCESS";
  payload: LoginResponsePayload;
}

interface Logout {
  type: "LOGOUT_SUCCESS";
}

type Action = Login | Logout;

export type AuthState = {
  typ_uzytkownika: UserRoles | null;
};

const initialState: AuthState = {
  typ_uzytkownika: null,
};

export const AuthReducer = (
  state: AuthState = initialState,
  action: Action
) => {
  switch (action.type) {
    case "LOGIN_SUCCESS": {
      return {
        typ_uzytkownika: action.payload.typ_uzytkownika,
      };
    }
    case "LOGOUT_SUCCESS": {
      return {
        typ_uzytkownika: null,
      };
    }
    default:
      return state;
  }
};
